import { Outlet, useSearchParams } from "react-router-dom";
// CUSTOM COMPONENTS
import LayoutBodyWrapper from "./components/LayoutBodyWrapper";
// DASHBOARD LAYOUT BASED CONTEXT PROVIDER
import LayoutProvider from "./context/layoutContext";
import DashboardFooter from "./components/DashboardFooter";
import { Box, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { WheatBox } from "../../pages/mobile/styled";
import DashboardHeader from "./components/DashboardHeader";
import { useCallback, useEffect } from "react";
import useSettings from "../../hooks/useSettings";
import useReadInitData from "../../hooks/useReadInitData";
import useSocket from "../../hooks/useSocket";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";



export default function MobileLayout({ children }) {
  const isMobile = true;
  const app = window.Telegram?.WebApp;
  const openTelegramLink = app?.openTelegramLink;
  const { settings, saveSettings } = useSettings();
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    const temp = searchParams.get("token");
    if (settings?.token !== temp && !!temp && temp?.length > 0) {
      saveSettings({ ...settings, token: temp });
    }
  }, [settings]);

  const { register } = useReadInitData()




  return (
    <LayoutProvider>
      <LayoutBodyWrapper>
        {isMobile ? (
          <>
            <>
              <DashboardHeader />
              <Box sx={{ position: 'absolute', top: '50px', left: 0, width: '100%', height: 'calc(100vh - 110px)', overflowY: 'scroll' }}>
                {children || <Outlet />}
              </Box>
              <DashboardFooter />
            </>
          </>
        ) : (
          <>
            <Stack
              alignItems={"center"}
              justifyContent={"flex-end"}
              height={"100vh"}>
              <WheatBox mb={"20vh"}>
                <Typography fontWeight={600} variant='h6'>
                  {t("Please login on your mobile device")}
                </Typography>
              </WheatBox>
            </Stack>
          </>
        )}
      </LayoutBodyWrapper>
    </LayoutProvider>
  );
}
